/* @flow */
import * as React from 'react';

const ChevronUpIndigo = props => (
  <svg width={20} height={12} viewBox="0 0 20 12" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      fillRule="evenodd"
      d="M18.5,11.5 L20,10 L10,0 L0,10 L1.5,11.5 L10,3 L18.5,11.5 Z"
    />
  </svg>
);

export default ChevronUpIndigo;



// WEBPACK FOOTER //
// ./src/assets/images/icons/chevron-up-indigo.js